import { ANY_OBJECT } from '@app/interfaces/interfaces';
import { Form, Input, InputNumber } from 'antd';
import React from 'react';
import { IUser } from '@app/interfaces/user';
import { useTranslation } from 'react-i18next';

interface CellInputProps extends React.HTMLAttributes<HTMLElement> {
  dataIndex: string;
  inputType: string;
  record: ANY_OBJECT;
  required: boolean;
  title: string;
  responsibleList: IUser[];
  buyerList: IUser[];
  sellerList: IUser[];
}

const CellInputNode: React.FC<CellInputProps> = ({ inputType, dataIndex, title, required }) => {
  const { t } = useTranslation();
  const InputNode = (inputType: string) => {
    switch (inputType) {
      case 'number':
        return <InputNumber />;
      default:
        return <Input />;
    }
  };

  return (
    <>
      <Form.Item
        name={dataIndex}
        style={{ margin: 0 }}
        rules={[
          {
            required,
            message: t('common.fieldRequired', { field: title }),
          },
        ]}
      >
        {InputNode(inputType)}
      </Form.Item>
    </>
  );
};

export default CellInputNode;
